import { IMatchingProfile, IKeyword, IApiMp, SupplierSearchTerm } from './types';
import { IApiOrganization } from '../organisations/types';
import { IUserName } from '../users/types';
import { User } from '../users';
import { IAccessControl } from '../acl/types';
import { BuyerType, JunctionLogic, ProfileType } from '@tendium/prom-types';

export class MatchingProfile implements IMatchingProfile {
  public readonly id: string;
  public readonly name: string;
  public readonly owners: IUserName[];
  public readonly subscribers: IUserName[];
  public readonly accessToEdit: boolean;
  public readonly accessControl: IAccessControl;
  public readonly profileType: ProfileType;
  public readonly nutsCodes?: string[];
  public readonly nutsCodesExact?: string[];
  public readonly cpvCodes?: string[];
  public readonly cpvCodesExact?: string[];
  public readonly bTagIds?: string[];
  public readonly keywords?: IKeyword[];
  public readonly buyerOrgIds?: string[];
  public readonly buyerSearchStrings?: string[];
  public readonly companies?: IApiOrganization[];
  public readonly supplierSearchTerms?: SupplierSearchTerm[];
  public readonly buyerTypes?: BuyerType[];
  public readonly supplierSearchLogic?: JunctionLogic;
  public readonly contractValueCurrency?: string;
  public readonly contractValueMin?: number;
  public readonly contractValueMax?: number;
  public readonly contractValueIncludeMissingValue?: boolean;

  constructor(apiMp: IApiMp) {
    this.id = apiMp.id;
    this.name = apiMp.name;
    this.owners = apiMp.owners.map(owner => new User(owner));
    this.subscribers = apiMp.subscribers.map(sub => new User(sub));
    this.accessToEdit = apiMp.accessToEdit;
    this.accessControl = apiMp.accessControl;
    this.nutsCodes = apiMp.nutsCodes;
    this.nutsCodesExact = apiMp.nutsCodesExact;
    this.cpvCodes = apiMp.cpvCodes;
    this.cpvCodesExact = apiMp.cpvCodesExact;
    this.bTagIds = apiMp.bTagIds;
    this.keywords = apiMp.keywords;
    this.buyerOrgIds = apiMp.buyerOrgIds;
    this.buyerSearchStrings = apiMp.buyerSearchStrings;
    this.supplierSearchTerms = apiMp.supplierSearchTerms;
    this.buyerTypes = apiMp.buyerTypes;
    this.supplierSearchLogic = apiMp.supplierSearchLogic;
    this.contractValueCurrency = apiMp.contractValueCurrency;
    this.contractValueMin = apiMp.contractValueMin;
    this.contractValueMax = apiMp.contractValueMax;
    this.profileType = apiMp.profileType;
    this.contractValueIncludeMissingValue = apiMp.contractValueIncludeMissingValue;
  }
}
